<template>
  <div class="uk-container uk-margin-medium-top">
    <div uk-grid>
      <div class="uk-width-1-4@m uk-width-1-1">
        <div
          class="uk-card uk-card-default uk-card-body uk-width-1-1 uk-card-small"
        >
          <h3>My Projects</h3>
          <p>
            {{ email }}
            <br />
            <a @click="logOut">Log Out</a>
          </p>
          <router-link to="/new-project">
            <button class="uk-button uk-button-default uk-width-1-1">
              Start a new project
            </button>
          </router-link>
        </div>
      </div>
      <div class="uk-width-3-4@m uk-width-1-1">
        <div class="uk-child-width-1-3@m uk-grid uk-grid-match" uk-grid>
          <div v-for="(project, index) in projects" :key="index">
            <div>
              <router-link :to="'/project/' + project.projectID">
                <div class="uk-card uk-card-default uk-card-body uk-card-small">
                  <img :src="projectImages[index]" />

                  <h4 class="uk-margin-small">{{ project.name }}</h4>
                  <p class="uk-margin-small uk-text-break">
                    Project ID: {{ project.projectID }}
                  </p>
                  <p class="uk-margin-small">
                    Created:
                    {{ project.created.seconds | moment("MMM Do, YYYY") }}
                  </p>
                  <button
                    class="uk-button uk-button-default uk-width-1-1 uk-margin-small"
                  >
                    View Project
                  </button>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import router from "@/router";

export default {
  name: "ClientView",
  components: {},
  filters: {},
  data() {
    return {
      email: "",
      projects: [],
      projectImages: []
    };
  },
  computed: {},
  mounted: function() {
    if (this.$route.query.email) {
      localStorage.email = this.$route.query.email.toLowerCase();
    }
    if (!localStorage.email) {
      router.push("log-in");
    }
    var self = this;
    // localStorage.email = "markjohnson303@gmail.com"
    // console.log(localStorage)
    this.email = localStorage.email.toLowerCase();
    const projectsRef = firebase.firestore().collection("projects");
    projectsRef
      .orderBy("projectID", "desc")
      .where("email", "==", self.email.toLowerCase())
      .get()
      .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          self.projects.push(doc.data());
          projectsRef
            .doc(doc.id)
            .collection("products")
            .orderBy("created", "desc")
            .limit(1)
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                self.projectImages.push(doc.data().proofImage);
              });
            });
        });
      })
      .catch(function(error) {
        console.error("Error getting document:", error);
      });
  },
  methods: {
    logOut() {
      localStorage.email = "";
      router.push("log-in");
    }
  }
};
</script>

<style type="text/css"></style>



// WEBPACK FOOTER //
// src/components/design-portal/ClientView.vue